import { LangfuseBrowserClient } from "@langfuse/browser";

type WidgetLangfuseConfig = {
  publicKey: string;
  baseUrl: string;
  environment?: string;
};

const POLLEN_API_KEY_REQUEST_HEADER = "x-pollen-api-key";

let langfuseClient: LangfuseBrowserClient | null = null;

export function initializeLangfuseClient(config: WidgetLangfuseConfig | null, apiKey?: string): void {
  if (!config?.baseUrl || !config.publicKey) {
    langfuseClient = null;
    return;
  }

  langfuseClient = new LangfuseBrowserClient({
    baseUrl: config.baseUrl,
    publicKey: config.publicKey,
    ...(config.environment ? { environment: config.environment } : {}),
    ...(apiKey && config.baseUrl.includes("/proxy-telemetry")
      ? { additionalHeaders: { [POLLEN_API_KEY_REQUEST_HEADER]: apiKey } }
      : {}),
  });
}

export function getLangfuseClient(): LangfuseBrowserClient | null {
  return langfuseClient;
}
